<div class="p-5 d-flex flex-column vh-100">
  <div class="modal-header mt-3 p-0 border-0 flex-shrink-0 mb-5">
    <div class="modelHeading mb-0">
      <h2 class="modalTitle mb-0">
        {{ isEdit ? 'Edit dataspace' : 'Create new dataspace' }}
      </h2>
    </div>
    <button type="button" class="closeBtn" (click)="onClose(false)"></button>
  </div>
  <div class="modal-body p-0 flex-grow-1" style="overflow-y: auto; height: 100%">
    <form [formGroup]="dataSpaceForm" style="padding-right: 5px">
      <div class="form-group">
        <label for="name">Dataspace Name</label>
        <input
          type="text"
          class="form-control"
          placeholder="Enter dataspace name"
          formControlName="name"
          appFirstLetterCaps
          autocomplete="off"
          id="name"
        />
        @if (dataSpaceForm.controls['name'].hasError('required') && showError) {
          <div class="invalid-feedback">*Please enter a dataspace name.</div>
        }
        @if (
          dataSpaceForm.controls['name'].hasError('minlength') &&
          showError &&
          dataSpaceForm.controls['name'].touched
        ) {
          <div class="invalid-feedback">*Dataspace name must be at least 3 characters long.</div>
        }
        @if (
          dataSpaceForm.controls['name'].hasError('maxlength') &&
          showError &&
          dataSpaceForm.controls['name'].touched
        ) {
          <div class="invalid-feedback">*Maximum length should be 60 characters long.</div>
        }
        @if (
          !dataSpaceForm.controls['name'].hasError('required') &&
          showError &&
          dataSpaceForm.controls['name'].hasError('whitespace')
        ) {
          <div class="invalid-feedback">*Dataspace name cannot include only blank space.</div>
        }
      </div>

      <div class="form-group">
        <label for="description">Description</label>
        <textarea
          class="form-control"
          rows="5"
          placeholder="Briefly describe the dataspace contents and purpose"
          formControlName="description"
          appFirstLetterCaps
          autocomplete="off"
          id="description"
        ></textarea>
        @if (dataSpaceForm.controls['description'].hasError('required') && showError) {
          <div class="invalid-feedback">*Please enter a description.</div>
        }
        @if (
          dataSpaceForm.controls['description'].hasError('minlength') &&
          showError &&
          dataSpaceForm.controls['description'].touched
        ) {
          <div class="invalid-feedback">*Description must be at least 3 characters long.</div>
        }
        @if (
          dataSpaceForm.controls['description'].hasError('maxlength') &&
          showError &&
          dataSpaceForm.controls['description'].touched
        ) {
          <div class="invalid-feedback">*Maximum length should be 500 characters long.</div>
        }
        @if (
          !dataSpaceForm.controls['description'].hasError('required') &&
          showError &&
          dataSpaceForm.controls['description'].hasError('whitespace')
        ) {
          <div class="invalid-feedback">*Description cannot include only blank space.</div>
        }
      </div>
    </form>
  </div>
  <div class="modalFooter">
    <div class="actions">
      <button
        type="submit"
        class="btn btn-md-popup btn-primary width100"
        (click)="createDataSpace()"
      >
        Save
      </button>
    </div>
  </div>
</div>
